import React from 'react'

/* Atoms */
import Button from 'components_new/atoms/Button'

/* Molecules */
import SimpleDialog from 'components_new/molecules/SimpleDialog'

interface TransferTableDialogProps {
  loading?: boolean
  open: boolean
  tableName: string
  onClose: () => void
  onConfirm: () => void
}

/**
 * Confirms promoting a single table out of the test environment. The
 * customer-wide equivalent lives under Våra kunder (TransferModelDialog) and
 * moves every table at once.
 */
const TransferTableDialog = (props: TransferTableDialogProps) => {
  const { loading, open, tableName, onClose, onConfirm } = props

  return (
    <SimpleDialog
      title="Överför tabell till produktion"
      contentText={
        <>
          Modelleringen av <b>{tableName}</b> kopieras från testmiljön till
          produktion och <b>ersätter tabellens nuvarande produktionsversion</b>.
          Övriga tabeller påverkas inte. Detta går inte att ångra.
        </>
      }
      open={open}
      onClose={loading ? () => null : onClose}
      actions={
        <>
          <Button disabled={loading} onClick={onClose} variant="text">
            Avbryt
          </Button>
          <Button loading={loading} onClick={onConfirm} variant="contained">
            Överför
          </Button>
        </>
      }
    />
  )
}

export default TransferTableDialog
